"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePercentageIcon = void 0;
var PercentageIcon_static_1 = require("./PercentageIcon.static");
function usePercentageIcon(_a) {
    var percentage = _a.percentage;
    var value = Math.max(0, Math.min(percentage, 100) / 100);
    return { arcPath: value === 1 ? undefined : describeArcPath({ center: PercentageIcon_static_1.center, radius: PercentageIcon_static_1.radius, angle: value * 360 }), value: value };
}
exports.usePercentageIcon = usePercentageIcon;
function describeArcPath(_a) {
    var center = _a.center, radius = _a.radius, angle = _a.angle;
    var start = polarToCartesian({ center: center, radius: radius, angle: angle });
    var end = polarToCartesian({ center: center, radius: radius });
    return [
        'M',
        end.x,
        end.y,
        'A',
        radius,
        radius,
        0,
        angle <= 180 ? '0' : '1',
        0,
        start.x,
        start.y,
        'L',
        center.x,
        center.y,
    ].join(' ');
}
function polarToCartesian(_a) {
    var _b = _a.center, x = _b.x, y = _b.y, radius = _a.radius, _c = _a.angle, angle = _c === void 0 ? 0 : _c;
    var angleInRadians = -((angle + 90) / 180.0) * Math.PI;
    return {
        x: x + radius * Math.cos(angleInRadians),
        y: y + radius * Math.sin(angleInRadians),
    };
}
var logic = {
    usePercentageIcon: usePercentageIcon,
};
exports.default = logic;
